import ExportBookingTable from './ExportBookingTable';

export default ExportBookingTable;
